import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  getAllMenu: () => {
    return axiosInstance.get(API_URL.DYNAMICMENU);
  },

  userBasedMenu: (id) => {
    return axiosInstance.get(`${API_URL.USERBASEMANU}/${id}`);
  },
};
